import { Box, Typography } from '@mui/material';
import { sxStyle } from './steps-styles';

const StepTexts = ({ title, subtitle, subtitleMobile, wrapperSx = {} }) => {
  return (
    <Box sx={{ ...sxStyle.boxStepsText, ...wrapperSx }}>
      <Typography sx={sxStyle.titleSteps}>{title}</Typography>

      <Typography sx={sxStyle.subtitleStepsBase}>{subtitle}</Typography>

      <Typography sx={sxStyle.subtitleStepsMobile}>{subtitleMobile}</Typography>
    </Box>
  );
};

export default StepTexts;
